import Provider from './src/provider';

export const wrapRootElement = Provider;
